import { render } from "./weight-summary-timbang-ulang.vue?vue&type=template&id=1a889937&ts=true"
import script from "./weight-summary-timbang-ulang.vue?vue&type=script&lang=ts"
export * from "./weight-summary-timbang-ulang.vue?vue&type=script&lang=ts"

import "./weight-summary-timbang-ulang.vue?vue&type=style&index=0&id=1a889937&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__